.wrap { display: flex; flex-direction: column; gap: 14px; padding: 16px 24px 24px; }
.group { display: flex; flex-direction: column; gap: 8px; }
.groupLabel { font-size: 13px; color: var(--text-value); }
.chips { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }

.brand {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px 14px; border: 1px solid var(--border-control); border-radius: 8px;
  background: #fff; font-size: 13px; color: var(--text-title); white-space: nowrap;
}
.brand:disabled { opacity: .5; cursor: not-allowed; }
.box {
  width: 14px; height: 14px; border-radius: 3px; border: 1.5px solid #c7ccd4;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 10px; color: #fff; flex-shrink: 0;
}
.you { color: var(--text-muted); font-size: 11px; }

.radio {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 8px 14px; border: 1px solid var(--border-control); border-radius: 8px;
  background: #fff; font-size: 13px; color: var(--text-title); white-space: nowrap;
}
.radio:disabled { opacity: .45; cursor: not-allowed; }
.radio.on { border-color: #2f6feb; color: #2f6feb; font-weight: 500; }
.dot { width: 14px; height: 14px; border-radius: 50%; border: 1.5px solid #c7ccd4; display: inline-flex; align-items: center; justify-content: center; }
.dotOn { width: 7px; height: 7px; border-radius: 50%; background: #2f6feb; }

.more { padding: 8px 14px; border: 1px solid var(--border-control); border-radius: 8px; font-size: 13px; color: var(--text-value); background: #fff; }
.card { border: 1px solid #eceef1; border-radius: 10px; padding: 16px; margin-top: 4px; }
.cardHead { display: flex; align-items: center; justify-content: flex-end; gap: 12px; margin-bottom: 8px; }
.state { padding: 48px 0; text-align: center; font-size: 13px; color: var(--text-muted); }
.note { margin-top: 10px; font-size: 11px; color: var(--text-muted); }
